import { Component, OnInit, ViewChildren, ViewChild, OnChanges, ElementRef, QueryList, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import * as moment from 'moment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import { UidrService } from 'src/app/uidr/uidr.service';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { Subject } from 'rxjs';
import { encryptionService } from 'src/app/common-service/cedService';
import { AcademicYearService } from '../common-service/academic-year.service';
@Component({
  selector: 'app-uidr-registration',
  templateUrl: './uidr-registration.component.html',
  styleUrls: ['./uidr-registration.component.css']
})
export class UidrRegistrationComponent implements OnInit {
  @ViewChild('myInput') myInputVariable: ElementRef;
  @ViewChild('mypresentSDCCerificate') mypresentSDCCerificate: ElementRef;
  uidrRegistrationForm: FormGroup;
  qualificationForm: FormGroup;
  submitted = false;
  qualificationsubmitted = false;
  maxEndDate: any;
  fieldArray: Array<any> = [];
  newAttribute: any = {};


  constructor(public tostar: ToastrService, public ced: encryptionService, public route: ActivatedRoute, 
    public fb: FormBuilder, public signin: UidrService, public helper: HelperService, 
    public usrmgtService: UsrmgtService, private spinner: NgxSpinnerService, public router: Router, 
    public activatedRoute: ActivatedRoute, public uidrService: UidrService, public academicYearService: AcademicYearService) { }
  get f() { return this.uidrRegistrationForm.controls; }
  countryList: any = [];
  collegeList: any = [];
  universityList: any = [];
  statesList: any = [];
  corescitiesList: any = [];
  permanentcitiesList: any = [];
  professionalcitiesList: any = [];
  allstateList: any = [];
  allcityList: any = [];
  courseList: any = [];
  specializationsList: any = [];
  specializations: any = [];
  filterspecializations: any = [];
  yearList: any = [];
  SDCList: any = [];
  editedIndex = -1;
  //editpermission: any = true;
  private acceptFileTypes = ["application/pdf"]
  private acceptFileTypesForPhoto = ["image/jpg", "image/gif", "image/png", "image/tif", "image/jpeg"]
  subscribe: Subject<any> = new Subject<any>();
  @ViewChild('dismissModal') closeBtn: ElementRef<HTMLElement>;
  @ViewChild('confirmModal') openBtn: ElementRef<HTMLElement>;
  uidrDetails = {
    uidrDetailsId: 0,
    uidrNumber: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fatherName: '',
    candidatePhoto: '',
    gender: '',
    dateOfBirth: '',
    email: '',
    mobile: '',
    nationality: 'Indian',
    firstRegistrationDate: '',
    firstRegistrationState: '',
    presentRegistrationStateId: '',
    firstRegistrationPart: 'A',
    firstRegistrationNo: '',
    presentRegistrationDate: '',
    presentRegistrationState: '',
    presentRegistrationPart: 'A',
    presentRegistrationNo: '',
    validUptoDate: '',
    correspondenceAddressLine1: '',
    correspondenceAddressLine2: '',
    correspondenceAddressCountry: 1,
    correspondenceAddressState: '',
    correspondenceAddressOtherState: '',
    correspondenceAddressCity: '',
    correspondenceAddressOtherCity: '',
    correspondenceAddressPincode: '',

    permanentAddressCountry: 1,
    permanentAddressState: '',
    permanentAddressOtherState: '',
    permanentAddressLine1: '',
    permanentAddressLine2: '',
    permanentAddressCity: '',
    permanentAddressOtherCity: '',
    permanentAddressPincode: '',


    professionalAddressCountry: 1,
    professionalAddressLine1: '',
    professionalAddressLine2: '',
    professionalAddressState: '',
    professionalAddressOtherState: '',
    professionalAddressCity: '',
    professionalAddressOtherCity: '',
    professionalAddressPincode: '',

    presentSDCCerificate: '',
    presentWorking: '',
    presentWorkingDetail: '',
    qualificationList: [],
    uidrStatus: 'Pending',
    reasonOfRejection: '',
  };
  courseId: any;
  specializationId: any;
  uidrQualification = {
    uidrQualificationId: '',
    uidrDetailsId: '',
    collegeCourse: '',
    collegeSpecialisation: '',
    passingYear: '',
    institution: {
      collegeId: ''
    },
    university: {
      universityId: ''
    },

  }
  UIDRDetailsId: any;
  selectedObject: any = [];
  minDate: string;
  userId: any;
  ngOnInit(): void {
    this.userId = sessionStorage.getItem('userId-usec');
    this.minDate = moment().format('YYYY-MM-DD');
    // Validations
    this.maxEndDate = this.uidrService.personalloadEndate();
    this.yearList = this.academicYearService.getAcademicYearList1948();

    this.uidrRegistrationForm = this.fb.group({

      // Personal Info
      firstName: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][a-zA-Z ]*$/)])],
      middleName: ['', Validators.compose([Validators.pattern(/^[^-\s][a-zA-Z ]*$/)])],
      lastName: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][a-zA-Z ]*$/)])],
      fatherName: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][a-zA-Z ]*$/)])],
      gender: ['', Validators.compose([Validators.required])],
      dob: ['', Validators.compose([Validators.required])],
      email: ["", Validators.compose([Validators.required, Validators.pattern(/^([\w.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)])],
      mobileNumber: ['', Validators.compose([Validators.required, Validators.pattern('[6-9]\\d{9}')])],
      nationality: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][a-zA-Z ]*$/)])],
      candidatePhoto: [''],

      //Registration Detail
      firstRegistrationStateId: ['', Validators.compose([Validators.required])],
      firstRegistrationDate: ['', Validators.compose([Validators.required])],
      firstRegistrationPart: ['', Validators.compose([Validators.required])],
      firstRegistrationNo: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z]|[0-9]$')])],

      presentRegistrationStateId: ['', Validators.compose([Validators.required])],
      presentRegistrationDate: ['', Validators.compose([Validators.required])],
      presentRegistrationPart: ['', Validators.compose([Validators.required])],
      presentRegistrationNo: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z]|[0-9]$')])],
      validUptoDate: ['', Validators.compose([Validators.required])],
      presentSDCCerificate: [''],

      country: [''],
      correspondenceAddressState: ['', Validators.compose([Validators.required])],
      correspondenceAddressCountry: ['', Validators.compose([Validators.required])],
      correspondenceAddressCity: ['', Validators.compose([Validators.required])],
      correspondenceAddressLine1: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      correspondenceAddressLine2: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      correspondenceAddressPincode: ['', Validators.compose([Validators.pattern(/^[^-\s][0-9 ]*$/)])],
      // same as permenant checkbox''
      permanentAddressCountry: ['', Validators.compose([Validators.required])],
      permanentAddressState: ['', Validators.compose([Validators.required])],
      permanentAddressCity: ['', Validators.compose([Validators.required])],
      permanentAddressLine1: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      permanentAddressLine2: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      permanentAddressPincode: ['', Validators.compose([Validators.minLength(2), Validators.maxLength(6)])],

      professionalAddressState: ['', Validators.compose([Validators.required])],
      professionalAddressCountry: ['', Validators.compose([Validators.required])],
      professionalAddressCity: ['', Validators.compose([Validators.required])],
      professionalAddressLine1: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      professionalAddressLine2: ['', Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9%a-zA-Z.@,/#$%&^() ]*$/)])],
      professionalAddressPincode: ['', Validators.compose([Validators.pattern(/^[^-\s][0-9 ]*$/)])],
      qualifications: this.fb.array([]),
      address: [false],
      presentWorking: ['', Validators.compose([Validators.required])],
      presentWorkingDetail: [''],
    });
    // this.isAlreadyUIDRExist();

    this.getStates(1);
    this.getAllCountry();
    this.getAllCourses();
    this.getSpecializations();
    this.getSDCList();
    this.getAllCollegeList();
    this.getAllUniversityList();
    this.GetUIDRDetails();
  }
  // isAlreadyUIDRExist() {
  //   this.uidrService.IsAlreadyUIDRExist(sessionStorage.getItem('userId-usec')).pipe().subscribe((result: any) => {

  //     this.editpermission = result;

  //   }, error => {
  //     console.log(error);
  //   });
  // }
  GetUIDRDetails() {
    if (this.route.snapshot.paramMap.get("uidrDetailsId") != null
      && this.route.snapshot.paramMap.get("uidrDetailsId") != "NaN") {
      this.route.params.subscribe(params => {
        this.UIDRDetailsId = +params.uidrDetailsId;
        this.uidrService.getUIDRDetails(this.UIDRDetailsId).pipe().subscribe((result: any) => {
          
          this.uidrDetails = result;
          if (this.uidrDetails.correspondenceAddressCountry == 1)
            this.getCities(this.uidrDetails.correspondenceAddressState, 'correspondenceAddressState', this.uidrDetails.correspondenceAddressCity);

          if (this.uidrDetails.professionalAddressCountry == 1)
            this.getCities(this.uidrDetails.professionalAddressState, 'professionalAddressState', this.uidrDetails.professionalAddressCity);

          if (this.uidrDetails.permanentAddressCountry == 1)
            this.getCities(this.uidrDetails.permanentAddressState, 'permanentAddressState', this.uidrDetails.permanentAddressCity);

          if (this.uidrDetails.qualificationList != null && this.uidrDetails.qualificationList.length > 0) {
            this.qualifications.controls.splice(0);
            this.qualifications.updateValueAndValidity();
            for (let i = 0; i < this.uidrDetails.qualificationList.length; i++) {
              this.uidrDetails.qualificationList[i].collegeCourse = this.uidrDetails.qualificationList[i].collegeSpecialisation.collegeCourse;
              this.validatequalifications(i);
            }
          }
        }, error => {
          console.log(error);
          this.helper.errorMessage(error);
        });
      });
    }
    else {
      // this.uidrService.GetUIDRDetailsByUser(sessionStorage.getItem('userId-usec')).pipe().subscribe((result: any) => {
      // this.uidrDetails = result;
      // this.uidrDetails .firstRegistrationPart="A";
      // this.uidrDetails .presentRegistrationPart="A";
      // this.uidrRegistrationForm.get('candidatePhoto').setValidators(Validators.required);
      // this.uidrRegistrationForm.get('candidatePhoto').updateValueAndValidity();
      // this.uidrRegistrationForm.get('presentSDCCerificate').setValidators(Validators.required);
      // this.uidrRegistrationForm.get('presentSDCCerificate').updateValueAndValidity();
      // this.qualifications.controls.splice(0);
      // this.qualifications.updateValueAndValidity();
      // this.uidrDetails.qualificationList = [];
      this.uidrDetails.correspondenceAddressCountry = 1;
      this.uidrDetails.permanentAddressCountry = 1;
      this.uidrDetails.permanentAddressCountry = 1;
      this.uidrDetails.nationality = 'Indian';
      this.uidrRegistrationForm.patchValue({
        'nationality': 'Indian',
      });
      this.addQualification(0);

      // }, error => {
      //   console.log(error);
      // });
    }
  }
  otherInsitutionChange(i) {
    if (this.uidrDetails.qualificationList[i].institution != null
      && this.uidrDetails.qualificationList[i].institution == 'Other') {
      this.qualifications.controls[i].get('otherInsitutionName').setValidators(Validators.required);
    }
    else
      this.qualifications.controls[i].get('otherInsitutionName').setValidators(null);

    this.qualifications.controls[i].get('otherInsitutionName').updateValueAndValidity();
  }
  otherUniversityChange(i) {
    if (this.uidrDetails.qualificationList[i].university != null
      && this.uidrDetails.qualificationList[i].university == 'Other') {
      this.qualifications.controls[i].get('otherUniversityName').setValidators(Validators.required);
    }
    else
      this.qualifications.controls[i].get('otherUniversityName').setValidators(null);

    this.qualifications.controls[i].get('otherUniversityName').updateValueAndValidity();
  }
  presentWorkingChange() {
    if (this.uidrDetails.presentWorking != null && this.uidrDetails.presentWorking != 'Faculty') {
      this.uidrRegistrationForm.get('presentWorkingDetail').setValidators(Validators.required);
    }
    else
      this.uidrRegistrationForm.get('presentWorkingDetail').setValidators(null);

    this.uidrRegistrationForm.get('presentWorkingDetail').updateValueAndValidity();
    if (this.uidrDetails.presentWorking != null && (this.uidrDetails.presentWorking == "Practitioner" ||
      this.uidrDetails.presentWorking == "Dental Surgeon at Govt. service at")) {
      this.uidrDetails.presentWorkingDetail = "Rural";
    }
  }
  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.specialisationId === c2.specialisationId : c1 === c2;
  }
  compareFnForSDC(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.entityMasterId === c2.entityMasterId : c1 === c2;
  }
  // compareFn( optionOne, optionTwo ) : boolean {
  //   return optionOne === optionTwo;
  // }
  // compareFnForSDC(o1: any, o2: any) {
  //   if(o1.name == o2.name && o1.entityMasterId == o2.entityMasterId )
  //   return true;
  //   else return false
  // }
  compareFnForCourse(c1: any, c2: any) {
    return c1 && c2 ? c1.courseId === c2.courseId : c1 === c2;
  }
  get qualifications(): FormArray {
    return this.uidrRegistrationForm.get('qualifications') as FormArray;
  }
  createQualificationFormGroup() {
    return this.fb.group({
      course: ['', Validators.compose([Validators.required])],
      specialisation: ['', Validators.compose([Validators.required])],
      passingYear: ['', Validators.compose([Validators.required])],
      institution: ['', Validators.compose([Validators.required])],
      otherInsitutionName: '',
      otherUniversityName: '',
      university: ['', Validators.compose([Validators.required])]
    })
  }
  validatequalifications(i) {
    let fg = this.createQualificationFormGroup();
    this.qualifications.push(fg);
  }
  addQualification(i) {
    this.qualificationsubmitted = true;
    if (!this.qualifications.valid)
      return false;
    if (this.qualifications.valid) {
      this.qualificationsubmitted = false;
      this.validatequalifications(i);
      this.uidrQualification = {
        uidrQualificationId: '',
        uidrDetailsId: '',
        collegeCourse: '',
        collegeSpecialisation: '',
        passingYear: '',
        institution: {
          collegeId: ''
        },
        university: {
          universityId: ''
        },
      }
      this.uidrDetails.qualificationList.push(this.uidrQualification);
    }
  }
  deleteQualification(idx: number) {

    this.qualifications.controls.splice(idx);
    this.uidrDetails.qualificationList.splice(idx, 1);
    this.qualifications.updateValueAndValidity();
  }
  fileChangeEvent(fileInput: any, filecolumn: any) {

    if (fileInput.target.files && fileInput.target.files[0]) {

      if (fileInput.target.files[0].size > 125000) {
        this.tostar.success('File size must 100KB or below.');
        return false;
      }

      this.uidrService.FileUploadForUIDRCertificate(fileInput.target.files).subscribe((data: any) => {
        if (data.success) {
          this.uidrDetails.presentSDCCerificate = data.message;
          this.tostar.success('File' + filecolumn + ' uploaded successfully');
        }
        else
          this.tostar.error('File' + filecolumn + ' uploaded not correctly');
      }, error => {
        console.log('File' + filecolumn + ' error>>> ' + error);
        error.status = error.status == 0 ? 500 : error.status
      });
    }
  }

  Age(e) {
    let year = new Date(e).getFullYear();
    let today = new Date().getFullYear();
  }

  getAllCourses() {
    this.uidrService.getAllCourses().pipe().subscribe((result: any) => {
      this.courseList = result;
    }, error => {
      console.log(error)
    });

  }
  getAllCollegeList() {
    this.usrmgtService.getAllCollegeList().pipe().subscribe((result: any) => {
      this.collegeList = result;
    }, error => {
      console.log(error)
    });

  }
  getAllUniversityList() {
    this.usrmgtService.getAllUniversityList().pipe().subscribe((result: any) => {
      this.universityList = result;
    }, error => {
      console.log(error)
    });

  }
  filterBycourseId(event: any, index: any) {
    //this.specializationsList = this.specializations.filter(specialtion => specialtion.collegeCourse.courseId === Number(course.courseId))
    this.uidrDetails.qualificationList[index].collegeSpecialisation.collegeCourse = event;
    this.uidrDetails.qualificationList[index].collegeSpecialisation = null;
  }
  filterbycollegeCourseId(course: any, index: any) {
    if (course != null && course != '' && course != undefined) {
      return this.specializations.filter(specialtion => specialtion.collegeCourse.courseId === Number(course.courseId))

    }
  }

  // Remove Files From List OF Files
  removedPhoto() {
    this.uidrDetails.candidatePhoto = '';
    this.myInputVariable.nativeElement.value = "";
    this.uidrRegistrationForm.get('candidatePhoto').setValidators(Validators.required);
    //     this.uidrRegistrationForm.get('presentSDCCerificate').setValidators(null);
    this.uidrRegistrationForm.get('candidatePhoto').updateValueAndValidity();
  }
  removedpresentSDCCerificate() {
    this.uidrDetails.presentSDCCerificate = '';
    this.mypresentSDCCerificate.nativeElement.value = "";

    this.uidrRegistrationForm.get('presentSDCCerificate').setValidators(Validators.required);

    // this.uidrRegistrationForm.get('presentSDCCerificate').setValidators(null);

    this.uidrRegistrationForm.get('presentSDCCerificate').updateValueAndValidity();
  }

  getSpecializations() {
    this.uidrService.getSpecializations().pipe().subscribe((result: any) => {
      this.specializations = result;
    }, error => {
      console.log(error);
    });
  }
  checkbox(event) {
    if (event.target.checked === true) {

      this.uidrDetails.permanentAddressCountry = this.uidrDetails.correspondenceAddressCountry;
      if (this.uidrDetails.permanentAddressCountry == 1) {
        this.uidrDetails.permanentAddressCity = this.uidrDetails.correspondenceAddressCity;
        this.uidrDetails.permanentAddressState = this.uidrDetails.correspondenceAddressState;
        this.getCities(this.uidrDetails.permanentAddressState, 'permanentAddressState', this.uidrDetails.correspondenceAddressCity);
      }
      else {
        this.uidrDetails.permanentAddressOtherCity = this.uidrDetails.correspondenceAddressOtherCity;
        this.uidrDetails.permanentAddressOtherState = this.uidrDetails.correspondenceAddressOtherState;
      }
      this.uidrDetails.permanentAddressLine1 = this.uidrDetails.correspondenceAddressLine1;
      this.uidrDetails.permanentAddressLine2 = this.uidrDetails.correspondenceAddressLine2;
      this.uidrDetails.permanentAddressPincode = this.uidrDetails.correspondenceAddressPincode;
    }
  }
  getAllCountry() {
    this.usrmgtService.countryList().subscribe((result: any) => {
      this.countryList = result;
    }, error => {
      console.log(error);
    });
  }
  getSDCList() {
    this.uidrService.getSDCList().subscribe((result: any) => {
      this.SDCList = result;
      let sdc = this.SDCList.filter(sdc => sdc.entityMasterId === Number(sessionStorage.getItem('entityId-usec')));
      if (sdc != null) {
        this.uidrDetails.nationality = 'Indian';
        this.uidrDetails.presentRegistrationState = sdc[0];
        this.uidrRegistrationForm.patchValue({
          'nationality': 'Indian',
        });
      }
    }, error => {
      console.log(error);
    });
  }
  //Get States
  getStates(value) {
    this.usrmgtService.getAllStates(value).subscribe(res => {
      this.statesList = res;
    }, error => {
      console.log(error);
    });
  }
  // Get City
  getCities(value: any, controlName: any, cityCurrentValue: any) {
    this.usrmgtService.getAllCities(value).subscribe(res => {
      if (controlName == 'correspondenceAddressState')
        this.corescitiesList = res;
      else if (controlName == 'permanentAddressState')
        this.permanentcitiesList = res;
      else if (controlName == 'professionalAddressState')
        this.professionalcitiesList = res;

      this.uidrDetails[controlName.replace('State', 'City')] = cityCurrentValue;
    }, error => {
      console.log(error);
    });
  }
  // keypressevent
  keyPress(event: any) {
    const pattern = /^[^-\s][a-z A-Z 0-9]*$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPresspincode(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPressAlpha(event: any) {
    const pattern = /[a-z A-Z 0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  keyPressAlphaNumberic(event: any) {
    const pattern = /[a-zA-Z]|[0-9]/;// /^([0-9]+|([a-zA-Z]+[0-9]+)*)$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  // back
  back() {
    if (sessionStorage.getItem('userId-usec') != null)
      this.router.navigate(['/main/internal/uidr/candidate/uidrList/']);
    else
      this.router.navigate(['/login']);
  }
  back1() {
    this.router.navigate(['../login'])
  }
  addFieldValue() {
    this.fieldArray.push(this.newAttribute)
    this.newAttribute = {};
  }


  deleteFieldValue(index) {
    this.fieldArray.splice(index, 1);
  }
  myEvent(event) {
    alert("event");
    event.nativeElement.click();
  }
  onSelectSDCCerificate(event, columnName) {

    if (event.target.files.length) {
      for (let i = 0; i < event.target.files.length; i++) {
        let file = event.target.files[0];
        if (columnName == 'candidatePhoto') {
          if (!this.acceptFileTypesForPhoto.includes(file.type)) {
            this.uidrService.displayMessage('Error', 'image file only accept');
            return;
          }
        }
        else {
          if (!this.acceptFileTypes.includes(file.type)) {
            this.uidrService.displayMessage('Error', 'PDf file only accept');
            return;
          }
        }
        if (file.size > 204800) {
          this.uidrService.displayMessage('Error', 'Please upload valid document with less than 200kb');
          return;
        }
        this.uidrService.FileUploadForUIDRCertificate(event.target.files).subscribe((data: any) => {
          if (data.success) {
            if (columnName == "presentSDCCerificate") {
              this.uidrDetails.presentSDCCerificate = data.message;
              this.uidrRegistrationForm.patchValue({
                'presentSDCCerificate': data.message
              });
            }
            else {
              this.uidrDetails.candidatePhoto = data.message;
              this.uidrRegistrationForm.patchValue({
                'candidatePhoto': data.message
              });
            }
            this.tostar.success('File ' + columnName + ' uploaded successfully');
          }
          else
            this.tostar.error('File Present SDC Cerificate uploaded not correctly');
        }, error => {
          console.log('File Present SDC Cerificate error>>> ' + error);
          error.status = error.status == 0 ? 500 : error.status
        });
      }
    }
  }
  saveUIDRRegistration() {
    this.submitted = true;
    this.qualificationsubmitted = true;
    // stop here if form is invalid
    if (!this.uidrRegistrationForm.valid)
      return;

    if (this.uidrRegistrationForm.valid) {
      this.spinner.show();
      // if (this.route.snapshot.paramMap.get("uidrDetailsId") != null
      //   && this.route.snapshot.paramMap.get("uidrDetailsId") != "NaN") {
      //   if (sessionStorage.getItem('userId-usec') != null)
          this.AddOrUpdateUIDRRegistration();
      // }
      // else {

      //   this.uidrService.IsAlreadyUIDRDetails(this.uidrDetails).subscribe((data: any) => {
      //     if (data.message == '') {
      //       this.ApplicantSignUp();
      //     }
      //     else {
      //       this.submitted = false;
      //       this.qualificationsubmitted = false;
      //       this.spinner.hide();
      //       this.displayErrorMsg('error', data.message);
      //     }
      //   }, error => {
      //     this.submitted = false;
      //     this.qualificationsubmitted = false;
      //     this.spinner.hide();
      //     error.status = error.status == 0 ? 500 : error.status
      //   });
      // }
    }
  }
  ApplicantSignUp() {

    let userMaster = {
      firstName: this.uidrDetails.firstName,
      middleName: this.uidrDetails.middleName,
      lastName: this.uidrDetails.lastName,
      emailId: this.uidrDetails.email,
      phoneNumber: this.uidrDetails.mobile,
      oAuthUserId: '',
      userAddress: {
        state: this.uidrDetails.professionalAddressState,
        city: this.uidrDetails.professionalAddressCity,
        line1: this.uidrDetails.professionalAddressLine1,
        zipCode: this.uidrDetails.professionalAddressPincode
      },
      defaultRole: {
        roleName: 'Dentist'
      }
    };

    this.uidrService.uidrSignup(userMaster).subscribe((data: any) => {
      if (data.response.respcode == '2000') {
        this.ced.encryptingProcess('access-token', data.access_token);
        this.ced.encryptingProcess('refresh-token', data.refresh_token);
        userMaster.oAuthUserId = data.oAuthUserId;
        this.UserRegistration(userMaster);
      } else if (data.response.respcode == '500') {
        this.spinner.hide();
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.spinner.hide();
        this.displayErrorMsg('error', 'Applicant Signup is Failed!!');
      }
    }, error => {
      this.submitted = false;
      this.qualificationsubmitted = false;
      this.spinner.hide();
      error.status = error.status == 0 ? 500 : error.status
      console.log(error);
    });

  }

  private UserRegistration(userMaster: any) {
    this.uidrService.uidrUserRegistration(userMaster).subscribe((data: any) => {

      this.spinner.hide();
      if (data.response.respcode == '200') {
        this.AddOrUpdateUIDRRegistration();
      } else if (data.response.respcode == '500') {
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.displayErrorMsg('error', 'Applicant Registration is Failed!!');
      }
    }, error => {
      this.spinner.hide();
      this.submitted = false
      console.log('UIDR ApplicantRegistration Form Submit >>>' + error);
      error.status = error.status == 0 ? 500 : error.status
    });
  }
  private displayErrorMsg(type: string, msg: string) {
    this.submitted = false;
    this.qualificationsubmitted = false;
    if (type == 'error') {
      this.tostar.error(msg, 'Error', {
        timeOut: 3000
      });
    }
  }
  AddOrUpdateUIDRRegistration() {
    this.submitted = true;
    this.qualificationsubmitted = true;
    // stop here if form is invalid
    if (!this.uidrRegistrationForm.valid)
      return;

    if (this.uidrRegistrationForm.valid) {
      this.spinner.show();
      if (this.uidrDetails.uidrStatus == 'Rejected') {
        this.uidrDetails.uidrDetailsId = null;
        this.uidrDetails.reasonOfRejection = null;
      }

      this.uidrDetails.nationality = 'Indian';
      this.uidrDetails.uidrStatus = 'Pending';
      let formControlObj = Object.assign({}, this.uidrRegistrationForm.value)

      this.uidrService.SaveUIDRDetails(this.uidrDetails).subscribe((data: any) => {
        this.tostar.success('Registered successfully', 'Success', {
          timeOut: 2000
        });
        this.spinner.hide();
        if (sessionStorage.getItem('userId-usec') != null)
          this.router.navigate(['/main/internal/uidr/uidrView/', data]);
        else
          this.router.navigate(['/login']);

      }, error => {
        this.spinner.hide();
        console.log('Uidr Registration >>> ' + error);
        error.status = error.status == 0 ? 500 : error.status
      });
    }

  }

}